module.exports = __webpack_public_path__ + "img/d32505e11a21a3698a3a874cce15bf18.png";